'use strict';

/**
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var CompositeView = require('base/Colido.CompositeView');
var SubscriptionReceiptItemView = require('modules/settings/views/partials/subscription/receipt-item');
var SubscriptionReceiptEmptyView = require('modules/settings/views/partials/subscription/receipt-empty');

var template = require('modules/settings/templates/partials/subscription/receipt-list.hbs');

var SubscriptionReceiptListView = CompositeView.extend({
    template: template,

    emptyView: SubscriptionReceiptEmptyView,

    childView: SubscriptionReceiptItemView,

    childViewContainer: '.subscription-receipt-list',
});

module.exports = SubscriptionReceiptListView;